export function stickyItem($sticky, $container) {
  if (
    !$sticky.length ||
    !$container.length ||
    Modernizr.touchevents ||
    !Modernizr.pointerevents
  ) {
    return;
  }

  const mouse = { x: 0, y: 0 };
  document.addEventListener('mousemove', function (e) {
    mouse.x = e.pageX;
    mouse.y = e.pageY;
  });

  setInterval(function () {
    const { left } = $container.offset();
    const { top } = $container.offset();
    const width = $container.outerWidth();
    const height = $container.outerHeight();

    let x = mouse.x - left;
    let y = mouse.y - top;

    if (x > width || y > height || x < 0 || y < 0) {
      // Back to start
      if (Math.abs($sticky.css('left').replace('px', '')) > 1) {
        $sticky.clearQueue().animate(
          {
            left: 0,
            top: 0,
          },
          250,
          'swing'
        );
      }
    } else {
      x -= width / 2;
      y -= height / 2;

      $sticky.clearQueue().animate(
        {
          left: `${x}px`,
          top: `${y}px`,
        },
        400,
        'swing'
      );
    }
  }, 50);
}
